import { AltraParte } from './altraparte';
import { AltroImportoLiquidato } from './altro-importo-liquidato';
import { Controparte } from './controparte';
import { CostoGestioneLiquidato } from './costo-gestione-liquidato';
import { ImportoLiquidato } from './importo-liquidato';
import { LegaleIncaricato } from './legale-incaricato';
import { SoggettoPratica } from './tipologiche/soggetto-pratica';
import { TipoLiquidato } from './tipologiche/tipo-liquidato';

export class Liquidato {
  id: string;
  dataLiquidato: number;
  note: string;
  societa: SoggettoPratica;
  tipoLiquidato: TipoLiquidato;
  importoLiquidato: ImportoLiquidato;
  costoGestioneLiquidato: CostoGestioneLiquidato;
  altroImportoLiquidato: AltroImportoLiquidato;
  controparte?: Controparte;
  altraParte?: AltraParte;
  legaleIncaricato?: LegaleIncaricato;
  ripartizioneEqua?: boolean;
  idEsito?:string;
  daEliminare?:boolean;
}
